import { useTranslation } from 'react-i18next';
import queryClient from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto, AIActionUsageStatsDto } from '@/Domain/api/Action/dto/Action.dto';
import { ActionBox } from '@/Domain/components/Action/ActionBox/ActionBox';
import { RemoveActionModal } from '@/Domain/components/Action/RemoveAction.modal';
import { useActivateShopifyMcp } from '@/Domain/hooks/Action/ShopifyMcp/useActivateShopifyMcp.hook';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

type Props = {
  action: ActionDto;
  stats?: AIActionUsageStatsDto;
};

export const ShopifyMcpActionBox = ({ action, stats }: Props) => {
  const { t } = useTranslation('shopify_mcp');
  const { toggleModal } = useModalStore();
  const handleFetchAction = async () =>
    await queryClient.fetchQuery({
      queryKey: [QueryKey.actions.shopifyMcp.get, action.id],
    });

  const { handleActive } = useActivateShopifyMcp(action);

  const handleDelete = () => {
    toggleModal(`${MODAL_NAMES.REMOVE_ACTION_MODAL_NAME}_${action.id}`);
  };

  const handleEdit = async () => {
    const shopifyMcpAction = await queryClient.ensureQueryData({
      queryKey: [QueryKey.actions.shopifyMcp.get, action.id],
    });
    toggleModal(MODAL_NAMES.SHOPIFY_MCP_DIALOG, { shopifyMcpAction });
  };

  return (
    <>
      <ActionBox
        dataTestId="shopify-mcp-action"
        action={action}
        stats={stats}
        onMouseEnterAction={handleFetchAction}
        onActive={handleActive}
        onEdit={handleEdit}
        onDelete={handleDelete}
        buttonLabel={t('button.edit')}
      />

      <RemoveActionModal actionId={action.id} />
    </>
  );
};
